import { ACTION_SET_DELIVERYPOINTS_MODE } from './types'

const setDeliveryPointsMode = ({ rest }, isDeliveryPoints) => ({
    payload: { isDeliveryPoints },
    type: ACTION_SET_DELIVERYPOINTS_MODE,
})

export default setDeliveryPointsMode
